module.exports = __webpack_public_path__ + "static/media/play_icon.29c3da34.svg";